import { clearUtmCookie } from "./utmTracker";

export const extractSessionId = (userOrSession) => {
  if (!userOrSession) return "";

  if (typeof userOrSession === "string") {
    return userOrSession;
  }

  return (
    userOrSession.sessionId ||
    userOrSession.session_id ||
    userOrSession.session ||
    userOrSession.sessionCode ||
    ""
  );
};

export const normalizeUserSession = (user) => {
  if (!user || typeof user !== "object") {
    return user;
  }

  const sessionId = extractSessionId(user);
  if (!sessionId) {
    return { ...user };
  }

  return {
    ...user,
    sessionId,
    session_id: sessionId,
  };
};

export const persistSessionId = (userOrSession) => {
  const sessionId = extractSessionId(userOrSession);

  if (sessionId) {
    localStorage.setItem("session", sessionId);
    localStorage.setItem("session_id", sessionId);
    // The attribution cookie is only useful up to the signup that claims it.
    // Once a session exists (signup OR login of an existing player) it can never
    // be claimed, so drop it: a later campaign visit then starts a fresh capture
    // instead of being blocked by a dead cookie.
    clearUtmCookie();
  }

  return sessionId;
};

export const getStoredSessionId = () => {
  return (
    localStorage.getItem("session") ||
    localStorage.getItem("session_id") ||
    ""
  );
};
